<template>
  <div class="references-tab-page-placeholder">
    <page-content-placeholder
      icon="help"
      prompt-text="No references found"
    >
      <template #message>
        Sorry, we couldn't find any references that match your
        criteria.
      </template>
      <template #action>
        <action-button
          color="primary"
          @click="$emit('clear-all-filters')"
        >
          <v-icon left>clear_all</v-icon>
          Clear All Filters
        </action-button>
      </template>
    </page-content-placeholder>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';
export default {
  name: 'ReferencesTabPagePlaceholder',
  components: { ActionButton, PageContentPlaceholder },
  emits: ['clear-all-filters'],
};
</script>

<style lang="scss" scoped>
.references-tab-page-placeholder {
  height: calc(100% - 39px);
}
</style>
